// ----------------------------------------------------------------------------
// Component: Ingredient Grid
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------


// Styles
import './_ingredients-grid.scss';
import '../../snippets/_containers/css-grid/css-grid'

import $ from 'jquery';


// Constant elements
const TAB_BUTTON = '.css-grid__item--card';
const TAB_CONTENT = '.css-grid__item--panel';

// Constant trigger classes
const OPEN_CLASS = 'js-active';

// Open first tab on page load
$('.css-grid--accordion').each(function(index) {
    $(this).children(TAB_BUTTON).first().addClass('js-active');
    $(this).children(TAB_CONTENT).first().addClass('js-active');
});

function tabOpen(tab) {
    const $panel = tab.next(TAB_CONTENT);
    const hash   = '#' + $panel.attr('id');

    // Close all other Panels
    tab.siblings().removeClass('js-active');

    // Toggle the Current Panel
    if (tab.hasClass('js-active')) {
        if($(window).width() < 1025) {
            tab.removeClass('js-active');
            $panel.removeClass('js-active');
        }else{
            tab.addClass('js-active');
            $panel.addClass('js-active');
        }
    } else {
        tab.addClass('js-active');
        $panel.addClass('js-active');

        // Add the hash  to the URL
        if (history.pushState) {
            history.pushState(null, null, hash);
        } else {
            location.hash = hash;
        }

        if($(window).width() < 1025) {
            // // Scroll to the Panel portion when opening
            $('html, body').animate({
                scrollTop: $panel.offset().top - 180
            }, 500);
        }
    }
}

// Card opens Panel
$(TAB_BUTTON).on('click', function(event) {
    tabOpen($(this));
});

// Accessibility keypress opens Panel
$(TAB_BUTTON).keypress(function(event) {
    if (event.which == 13) {
        tabOpen($(this));
    }
});

// Close Button Closes Panel
$('.css-grid__item-close').on('click', function(event) {
    var $card  = $(this).parents('.css-grid__item').prev('.css-grid__item--card');
    var $panel = $(this).parents('.css-grid__item--panel');

    // Close the relevant panel
    $card.removeClass('js-active');
    $panel.removeClass('js-active');
});
